import styled from 'styled-components';

export const CheckModal = styled.div`
  padding: ${({ theme }) => theme.spacing.x2};
  width: 100%;
`;

export const InfoTitle = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: bold;
`;
export const GrayCard = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.x2};
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
`;

export const PointBoxBlue = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.spacing.x25};
  height: ${({ theme }) => theme.spacing.x20};
  background: ${({ theme }) => theme.palette.white};
  margin-bottom: ${({ theme }) => theme.spacing.x2};
  border-radius: ${({ theme }) => theme.rounded.x2};
  border: 2px solid ${({ theme }) => theme.palette.secondary};
`;
export const PointBoxText = styled.div`
  color: ${({ theme }) => theme.palette.secondary};
  font-size: ${({ theme }) => theme.fs.xs};
  font-weight: bold;
`;
export const PointBoxNumber = styled.div`
  color: ${({ theme }) => theme.palette.secondary};
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: 800;
  margin-top: ${({ theme }) => theme.spacing.x2};
`;
export const PointBoxGreen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.spacing.x25};
  height: ${({ theme }) => theme.spacing.x20};
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.rounded.x2};
  border: 2px solid ${({ theme }) => theme.palette.secondary};
`;
export const PointBoxTextGreen = styled.div`
  color: ${({ theme }) => theme.palette.success};
  font-size: ${({ theme }) => theme.fs.xs};
  font-weight: bold;
`;
export const PointBoxNumberGrren = styled.div`
  color: ${({ theme }) => theme.palette.success};
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: 800;
  margin-top: ${({ theme }) => theme.spacing.x2};
`;
export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
export const Btn = styled.div`
  margin-top: ${({ theme }) => theme.spacing.x4};
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const BtnText = styled.div`
  margin-right: ${({ theme }) => theme.spacing.x2};
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const SuccessStep = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.x5}`};
`;
export const ParentAlert = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.x5} ${theme.spacing.x2}`};
`;
export const Divider = styled.div`
  margin: ${({ theme }) => ` ${theme.spacing.x5} 0 ${theme.spacing.x4}`};
  border: 1px solid ${({ theme }) => theme.palette.whiteGray};
`;

export const CheckMilageModalContainer = styled.div`
  width: 566px;
  max-width: 95%;
`;
